import "../dashboard-sections.css";

const PPSummaryBox = ({ icon, label, value, note, noteType = "neutral", danger = false, isLoading = false }) => (
<>
  <div className="pp-metric-card">
    <div className="pp-metric-top">
      <span className="pp-metric-label">{label}</span>
      <span className={`pp-metric-icon${danger ? " danger" : ""}`}>{icon}</span>
    </div>
    <div className={`pp-metric-value${danger ? " danger" : ""}`}>
      {isLoading
        ? <span className="db-shimmer" style={{ height: 32, width: 100, display: "block" }} />
        : (typeof value === "number" ? value.toLocaleString() : value)
      }
    </div>
    {note && <div className={`pp-metric-note ${noteType}`}>{note}</div>}
  </div>
</>
);

export default PPSummaryBox;
